import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function ParallaxSection({ children, className = "", style = {} }) {
  const ref = useRef(null);

  // Scroll progress
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });

  // Reduced scale effect: 0.95 → 1 → 0.95 (less zoom)
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.95, 1, 0.95]);

  // Slight opacity effect: 0.7 → 1 → 0.7
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [0.7, 1, 0.7]);

  return (
    <motion.section
      ref={ref}
      style={{
        scale,
        opacity,
        position: "relative",
        zIndex: 2,
        transition: "scale 0.8s ease-out, opacity 0.8s ease-out",
        ...style
      }}
      className={`parallax-section ${className}`}
    >
      {children}
    </motion.section>
  );
}
